var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"certified-logo tw-text-center",attrs:{"id":"certified-logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }